import React from "react";
import "../styles/infoBarSelection.scss";

const formatSelections = (selections, options) => {
  if (selections.length === 1)
    return options.find((e) => e.id === selections[0])?.name;
  else return `${selections.length} Selected`;
};

const InfoBarSelection = ({ isActive, item, values, type }) => {
  // console.log(values);
  return (
    <div
      className="info-bar-selection-container"
      style={{
        opacity: isActive ? 1 : 0.56,
      }}
    >
      {item.icon && <img src={item.icon} alt="icon" />}
      <div className="info-select">
        <p
          className={values.length > 0 ? "label-select small" : "label-select"}
        >
          {item.label}
        </p>
        {values.length > 0 && (
          <p className="selection">
            {type && type === "date"
              ? values[0]
              : formatSelections(values, item.options)}
          </p>
        )}
      </div>
    </div>
  );
};

export default InfoBarSelection;
